import MainLayout from 'layout/MainLayout';
import Portal from '../views/portal/Portal';
import PurchaseOrders from '../views/purchase-orders/PurchaseOrders';
import PurchaseOrderDetails from '../views/purchase-orders/PurchaseOrderDetails';
import ProtectedRoute from './ProtectedRoutes';
import useAccessLevel from '../helpers/useAccessLevel';
import createNavPages from '../menu-items/createNavPages';

// ==============================|| MAIN ROUTING ||============================== //

/**
 * Thin wrapper so MainLayout receives nav items built from the user's access level.
 */
const AppLayout = () => {
    const { itAccess, userAccess } = useAccessLevel();
    const navItems = createNavPages({ itAccess, userAccess });
    return <MainLayout navItems={navItems} />;
};

const MainRoutes = {
    path: '/',
    element: <AppLayout />,
    children: [
        {
            path: '/',
            element: <Portal />
        },
        {
            path: '/portal',
            element: <Portal />
        },
        {
            path: '/purchase-orders',
            element: (
                <ProtectedRoute>
                    <PurchaseOrders />
                </ProtectedRoute>
            )
        },
        {
            path: '/goodsin-admin/po/:poId',
            element: (
                <ProtectedRoute>
                    <PurchaseOrderDetails />
                </ProtectedRoute>
            )
        }
    ]
};

export default MainRoutes;